// extracted by mini-css-extract-plugin
export default {"container":"option_container__JPxgi","text":"option_text__2iBuO","options":"option_options__PHyl0","option":"option_option__p0R4W","selectedOpt":"option_selectedOpt__hOlK5"};